import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { WidgetFooter, Pill } from './common';

/**
 * Generic status card for any pinned object. The backend adapter for the
 * entity produces the same shape for every type:
 *   { unavailable, title, subtitle, status_label, status_tone,
 *     headline, rows: [{label, value}], url, open_label }
 */
const PinnedObjectWidget = ({ data, onRemove }) => {
  if (data.unavailable) {
    return (
      <div className="mydesk-unavailable">
        <span className="mydesk-row-icon tone-neutral"><FontAwesomeIcon icon={faEyeSlash} /></span>
        <strong>No longer available</strong>
        <span>This item was removed or is outside your access. The card will not load again.</span>
        {onRemove && (
          <button type="button" className="mydesk-chip mydesk-chip-add" onClick={onRemove}>
            Remove from My Workspace
          </button>
        )}
      </div>
    );
  }

  return (
    <>
      <div className="mydesk-pinned-lead">
        <div className="mydesk-pinned-lead-text">
          {data.subtitle && <div className="mydesk-pinned-subtitle">{data.subtitle}</div>}
          {data.headline && <div className="mydesk-pinned-headline">{data.headline}</div>}
        </div>
        {data.status_label && <Pill tone={data.status_tone || 'neutral'}>{data.status_label}</Pill>}
      </div>
      {(data.rows || []).filter((row) => row.value !== null && row.value !== undefined && row.value !== '').map((row) => (
        <div key={row.label} className="mydesk-kv">
          <span className="mydesk-kv-label">{row.label}</span>
          <span className="mydesk-kv-value">{row.value}</span>
        </div>
      ))}
      <WidgetFooter label={data.open_label || 'Open'} url={data.url} />
    </>
  );
};

export default PinnedObjectWidget;
